import MaterialTableTS from "../../../../components/tables/MaterialTableTS";
import { UsersIcon } from "@heroicons/react/24/solid";
import { CSVLink } from "react-csv";
import { useSetRecoilState, useRecoilValue } from "recoil";
import { mainSelectedTab } from "../../atoms";
import { useHistory } from "react-router-dom";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { employeeFromReports } from "../../Employees/Confie/atoms/atoms";
import DownloadButton from "../../../../components/DownloadButton";
import { accountAtom } from "../../../Login/atoms/AccountAtom";
import { useGetActiveSplcEmployees } from "./api/useGetActiveSPLCEmployees";
import { getActiveEmployeeColumns } from "./columns/ActiveEmployeesColumns";
import { IActiveEmployeeList } from "./types";

export const ActiveSPLCEmployees = () => {
  const { data: activeSplcEmployees, isLoading: activeSplcEmployeesLoading } =
    useGetActiveSplcEmployees();
  const setShowFromReports = useSetRecoilState(employeeFromReports);
  const setSelectedIndex = useSetRecoilState(mainSelectedTab);
  const history = useHistory();
  const userPermissions = useRecoilValue(permissionsSelector);
  const user = useRecoilValue(accountAtom);

  //Date Format
  const formatDate = (date: string | Date): string => {
    const d = new Date(date);
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const day = String(d.getDate()).padStart(2, "0");
    const year = d.getFullYear();

    return [month, day, year].join("/");
  };

  const matchesEmployeeTypeFilter = (employeeTypeName: string): boolean => {
    if (user.isFranchise && user.isNonFranchise) return employeeTypeName !== "";
    if (user.isFranchise)
      return employeeTypeName?.toLowerCase() === "franchise";
    return employeeTypeName?.toLowerCase() !== "franchise";
  };

  //For downloading table data
  const exportdata = activeSplcEmployees
    ?.filter((x) => matchesEmployeeTypeFilter(x.employeeTypeName))
    ?.map((emp: IActiveEmployeeList) => {
      return {
        "Full Name": emp.fullname,
        "Employee ID": '=""' + emp.employeenumber + '""',
        State: emp.state,
        "Local Office #": emp.storeNumber,
        Department: emp.department,
        "Employee Type": emp.employeeTypeName,
        "Created Date": emp.createdDate ? formatDate(emp.createdDate) : "",
        "Hire Date": emp.hiredate ? formatDate(emp.hiredate) : "",
        "Employment Type": emp.employmenttype,
        "IQ Reports To": emp.reportsToFullname,
        "UltiPro Reports To": emp.ultiProReportsTo,
        "IQ Employee Status": emp.status,
        "UltiPro Employee Status": emp.ultiProEmployeeStatus,
        "IQ Job Title": emp.title,
        "UltiPro Job Title": emp.ultiProJobTitle,
        "IQ Office Location": emp.officeName,
        "UltiPro Office Location": emp.workLocation,
        "IQ Last Modified Date": emp.lastModifiedDate
          ? formatDate(emp.lastModifiedDate)
          : " ",
        "UltiPro Last Modified Date": emp.ultiProLastModifiedDate
          ? formatDate(emp.ultiProLastModifiedDate)
          : " ",
      };
    });
  let dateTimeToday = new Date(new Date().toLocaleString()).toLocaleString();
  const csvReport = {
    filename: "ActiveSPLCEmployees_" + dateTimeToday + ".csv",
    data: exportdata ?? [],
  };

  const employeeColumns = getActiveEmployeeColumns({
    action: "ActiveSPLCEmployeeReports",
    formatDate,
    history,
    userPermissions,
    setSelectedIndex,
    setShowFromReports,
  });

  return (
    <div className="text-xs items-center">
      <div className="">
        <div className="mx-4 mt-4 overflow-x-auto">
          <div className="flex mb-2 gap-2 items-center">
            <div>
              <UsersIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
            </div>
            <div className="flex flex-col leading tight">
              <div className="text-gray-500 text-md font-medium">
                Report: Employees & Offices
              </div>
              <div className="flex items-center font-bold text-lg text-primary">
                Active SPLC Employee Report
              </div>
            </div>
          </div>
          <div className="mt-2" />
          <div className="flex justify-between mb-2 mr-2">
            <div className="flex items-center gap-1">
              <span className="text-gray-500 text-sm">Total Records: </span>
              <span className="text-primary text-base font-semibold">
                {user.isFranchise && user.isNonFranchise
                  ? activeSplcEmployees?.length
                  : activeSplcEmployees?.filter(
                      (x) =>
                        x.employeenumber !== "" &&
                        (user.isFranchise
                          ? x.employeeTypeName?.toLowerCase() === "franchise"
                          : x.employeeTypeName?.toLowerCase() !== "franchise")
                    )?.length}
              </span>
            </div>

            <CSVLink {...csvReport}>
              <DownloadButton
                buttonValue="Download File"
                onClick={() => exportdata}
                className={undefined}
                disabled={undefined}
              />
            </CSVLink>
          </div>
        </div>
        <div className="box-shadow mx-4 mb-4 mt-2 overflow-x-auto grid grid-row">
          <MaterialTableTS
            data={
              user.isFranchise && user.isNonFranchise
                ? activeSplcEmployees
                : activeSplcEmployees?.filter(
                    (x) =>
                      x.employeenumber !== "" &&
                      (user.isFranchise
                        ? x.employeeTypeName?.toLowerCase() === "franchise"
                        : x.employeeTypeName?.toLowerCase() !== "franchise")
                  )
            }
            isLoading={activeSplcEmployeesLoading}
            columns={employeeColumns}
            showTitle={false}
          />
        </div>
      </div>
    </div>
  );
};
